import script from "./checksBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./checksBlock.vue?vue&type=script&setup=true&lang=ts"

import "./checksBlock.vue?vue&type=style&index=0&id=01eaedc7&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01eaedc7"]])

export default __exports__